import { Injectable, TemplateRef } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DrawerService {
  private drawerRef: any;
  private contentTemplate: TemplateRef<any> | null = null;
  private drawerWidth: string = '400px';
  // Observable to handle drawer open/close
  private drawerToggleSource = new Subject<boolean>();
  drawerToggle$ = this.drawerToggleSource.asObservable();

  // Observable to pass dynamic content
  private drawerContentSource = new Subject<any>();
  drawerContent$ = this.drawerContentSource.asObservable();

  setDrawerRef(ref: any) {
    this.drawerRef = ref;
  }

  open(content?: TemplateRef<any>) {
    if (content) this.contentTemplate = content;
    this.drawerRef?.open();
  }

  close() {
    this.drawerRef?.close();
  }

  getContentTemplate(): TemplateRef<any> | null {
    return this.contentTemplate;
  }

  getDrawerWidth(): string {
    return this.drawerWidth;
  }

  setDrawerWidth(width: string) {
    this.drawerWidth = width;
  } 

  // Method to open or close the drawer
  toggleDrawer(isOpen: boolean) {
    this.drawerToggleSource.next(isOpen);
  }

  // Method to set content for the drawer
  setDrawerContent(content: any) {
    this.drawerContentSource.next(content);
  }

}
